// Shared mutable game state, centralising the cross-module C globals.
// Scalars live on G; the rooms array and map buffers are shared objects that
// modules mutate in place (mirroring the C externs).

import { MAP_W, MAP_H } from './constants';
import { Room, newRoom } from './types';

export const rooms: Room[] = Array.from({ length: 3000 }, () => newRoom());

export const map = {
  w: MAP_W,
  h: MAP_H,
  m: new Uint8Array(MAP_W * MAP_H),
  r: new Int32Array(MAP_W * MAP_H),
  totalRooms: 0,
};

export const boss_names = ['MERIDIAN', 'ATARAXIA', 'MERODACH', 'WERVYN ANIXIL'];
export const artifact_names = [
  "Holy Sword 'Balmung'",
  "Mystic Halberd 'Amenonuhoko'",
  "Divine Bow 'Gandiva'",
  'Cursed Seal of Yahveh',
];

export const percent_required = [15, 40, 60, 75];

// All shared scalar globals.
export const G = {
  // seed used to (re)generate the current dungeon
  seed: 1,

  // mapgen
  total_rooms: 0,
  place_of_power: 0,
  game_load: 0,

  // player / levelblit
  player_x: 0,
  player_y: 0,
  player_dying: 0,
  magic_circuit: 0,
  circuit_range: 100,
  release_range: 100,
  release_x: 0,
  release_y: 0,
  release_str: 0,
  shield_hp: 0,
  shield_recover: 0,
  player_gems: 0,
  checkpoints_found: 0,
  circuit_size: 1000,
  first_game: 1,
  player_hp: 3,
  player_lives: 5,
  player_lives_part: 0,
  player_room: 0,
  player_dir: 0,
  player_wlk: 0,
  player_walk_speed: 5,
  wlk_wait: 8,
  circuit_release: 0,
  scroll_home: 0,
  enter_pressed: 0,
  explored: 0,
  voluntary_exit: 0,
  player_shield: 0,
  circuit_fillrate: 2,
  circuit_recoverrate: 3,
  scroll_x: 0,
  scroll_y: 0,
  map_enabled: 0,
  prv_player_room: -1,
  specialmessage: 0,
  specialmessagetimer: 0,
  checkpoint_x: 0,
  checkpoint_y: 0,
  enter_room_x: 0,
  enter_room_y: 0,
  opening_door_x: 0,
  opening_door_y: 0,
  opening_door_i: 0,
  opening_door_n: 0,
  agate_knife_loc: -1,
  expired_ms: 0,
  training: 0,
  show_ending: 0,
  game_paused: 0,
  game_running: 1,
  tele_select: 0,

  artifacts: new Array(12).fill(0) as number[],

  // demon
  total_enemies: 0,
  killed_enemies: 0,
  total_gems: 0,

  // boss
  boss_fight_mode: 0,
  current_boss_room: 0,
  current_boss: 0,
  boss_lives: 0,
  proxy_seek: 0,
  boss_dlg: 0,
  resetboss: 0,

  // gamemap
  c_scroll_x: 0,
  c_scroll_y: 0,
};
